export enum ImportPathEnum {
  classic = 'classic',
  assisted = 'assisted'
}
